import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Search, Bell, User } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const isActive = (path) => location.pathname === path

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50" data-component-path="client/src/components/Navbar.jsx" data-component-line="13:5" data-component-id="client/src/components/Navbar.jsx:13:5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="14:7" data-component-id="client/src/components/Navbar.jsx:14:7">
        <div className="flex justify-between items-center h-16" data-component-path="client/src/components/Navbar.jsx" data-component-line="15:9" data-component-id="client/src/components/Navbar.jsx:15:9">
          <div className="flex items-center gap-2" data-component-path="client/src/components/Navbar.jsx" data-component-line="16:11" data-component-id="client/src/components/Navbar.jsx:16:11">
            <Link to="/" className="flex items-center gap-2" data-component-path="client/src/components/Navbar.jsx" data-component-line="17:13" data-component-id="client/src/components/Navbar.jsx:17:13">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center" data-component-path="client/src/components/Navbar.jsx" data-component-line="18:15" data-component-id="client/src/components/Navbar.jsx:18:15">
                <Search className="w-6 h-6 text-white" data-component-path="client/src/components/Navbar.jsx" data-component-line="19:17" data-component-id="client/src/components/Navbar.jsx:19:17" />
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" data-component-path="client/src/components/Navbar.jsx" data-component-line="21:15" data-component-id="client/src/components/Navbar.jsx:21:15">
                GrantFlow
              </span>
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="27:11" data-component-id="client/src/components/Navbar.jsx:27:11">
            <Link
              to="/"
              className={`font-medium transition-colors ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
              data-component-path="client/src/components/Navbar.jsx" data-component-line="28:13" data-component-id="client/src/components/Navbar.jsx:28:13"
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`font-medium transition-colors ${
                isActive('/about') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
              data-component-path="client/src/components/Navbar.jsx" data-component-line="37:13" data-component-id="client/src/components/Navbar.jsx:37:13"
            >
              About
            </Link>
            <button className="flex items-center justify-center gap-2 text-gray-700 hover:text-blue-600 transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="45:13" data-component-id="client/src/components/Navbar.jsx:45:13">
              <Bell className="w-5 h-5" data-component-path="client/src/components/Navbar.jsx" data-component-line="46:15" data-component-id="client/src/components/Navbar.jsx:46:15" />
            </button>
            <button className="flex items-center justify-center gap-2 h-11 px-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition-all duration-200" data-component-path="client/src/components/Navbar.jsx" data-component-line="48:13" data-component-id="client/src/components/Navbar.jsx:48:13">
              <User className="w-5 h-5" data-component-path="client/src/components/Navbar.jsx" data-component-line="49:15" data-component-id="client/src/components/Navbar.jsx:49:15" />
              <span data-component-path="client/src/components/Navbar.jsx" data-component-line="50:15" data-component-id="client/src/components/Navbar.jsx:50:15">Sign In</span>
            </button>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            data-component-path="client/src/components/Navbar.jsx" data-component-line="55:11" data-component-id="client/src/components/Navbar.jsx:55:11"
          >
            {isOpen ? (
              <X className="w-6 h-6 text-gray-700" data-component-path="client/src/components/Navbar.jsx" data-component-line="60:15" data-component-id="client/src/components/Navbar.jsx:60:15" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" data-component-path="client/src/components/Navbar.jsx" data-component-line="62:15" data-component-id="client/src/components/Navbar.jsx:62:15" />
            )}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200" data-component-path="client/src/components/Navbar.jsx" data-component-line="69:9" data-component-id="client/src/components/Navbar.jsx:69:9">
          <div className="px-4 py-4 space-y-3" data-component-path="client/src/components/Navbar.jsx" data-component-line="70:11" data-component-id="client/src/components/Navbar.jsx:70:11">
            <Link
              to="/"
              className={`block px-4 py-2 rounded-lg font-medium ${
                isActive('/') ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsOpen(false)}
              data-component-path="client/src/components/Navbar.jsx" data-component-line="71:13" data-component-id="client/src/components/Navbar.jsx:71:13"
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`block px-4 py-2 rounded-lg font-medium ${
                isActive('/about') ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-50'
              }`}
              onClick={() => setIsOpen(false)}
              data-component-path="client/src/components/Navbar.jsx" data-component-line="81:13" data-component-id="client/src/components/Navbar.jsx:81:13"
            >
              About
            </Link>
            <button className="w-full flex items-center justify-center gap-2 h-11 px-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition-all duration-200" data-component-path="client/src/components/Navbar.jsx" data-component-line="90:13" data-component-id="client/src/components/Navbar.jsx:90:13">
              <User className="w-5 h-5" data-component-path="client/src/components/Navbar.jsx" data-component-line="91:15" data-component-id="client/src/components/Navbar.jsx:91:15" />
              <span data-component-path="client/src/components/Navbar.jsx" data-component-line="92:15" data-component-id="client/src/components/Navbar.jsx:92:15">Sign In</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar